// Layout constants (alineados con estándares PMS: Cloudbeds/Mews/Octopus24)
export const ROW_HEIGHT = 44; // densidad mejorada (antes 52)
export const LEFT_COL_WIDTH = 232; // más espacio para tipo + tags (antes 200)
export const CELL_WIDTH = 56; // ancho por día — permite tarifa + disponibilidad (antes 32)
export const MINI_CALENDAR_HEIGHT = 40;
export const RATE_ROW_HEIGHT = 28; // franja de tarifa + disponibilidad
export const GROUP_HEADER_HEIGHT = 32; // encabezado de grupo en sidebar

// Alturas de header timeline
export const MONTH_ROW_HEIGHT = 28;
export const WEEK_ROW_HEIGHT = 22;
export const DAY_ROW_HEIGHT = 46;
